// @ts-check
import {
  FreeTierGridItem,
  FreeTierLastInLineGridItem,
  GridWrapper
} from './AllContributorsDoraDashboard.style';
import { EducationalTabs } from './educationalTabs/EducationalTabs';
import CycleTimeWidget from './Widgets/CycleTimeWidget';
import CallToActionSlides from './Widgets/CallToActionSlide';
import MetricWidget from './Widgets/MetricWidget';
import useWidgetDataCalculation from './useWidgetsDataCalculation';
import { useEffect } from 'react';
import { getAvailableMetrics } from 'common/services/metrics.service';
import { useSelector } from 'react-redux';
import { reposProcessPercentageSelector } from 'state/selectors/jobs';
import { licenseSelector } from 'state/selectors/license';
import AllContributorsBanner from './Widgets/AllContributorsBanner';

const AllContributorsDoraDashboard = ({
  cycleTimeTrendData,
  cycleTimeAverage,
  totalCycleTimeInMinutes,
  pipelineMilestones,
  isLodingCycleTimeData
}) => {
  const license = useSelector(licenseSelector);
  const { isPaid, isTrial } = license;
  const isFreePlan = !isPaid && !isTrial;

  const reposProcessPercentage = useSelector(reposProcessPercentageSelector);
  const {
    widgets,
    widgetsMetricsNames,
    metricsWidgetData,
    setMetricsWidgetData,
    selectedTeamId,
    formattedV3Data,
    V3DataCalculated,
    isWidgetLoading,
    metricsPerGranularityMapped,
    metricsWidgetsByName
  } = useWidgetDataCalculation({
    isLodingCycleTimeData,
    reposProcessPercentage
  });
  const getWidgetsMetricsData = async () => {
    let metrics = {};

    try {
      metrics = await getAvailableMetrics();
      const data = metrics ? Object.values(metrics) : [];

      const widgetsData = data.filter(metric => {
        const metricName = metric?.metrics?.[0]?.name || '';
        return widgetsMetricsNames.includes(metricName);
      });
      setMetricsWidgetData(widgetsData);
    } catch (e) {
      setMetricsWidgetData([]);
    }
  };

  useEffect(() => {
    getWidgetsMetricsData();
  }, []);

  return (
    <>
      {!isFreePlan && <AllContributorsBanner />}
      <GridWrapper container>
        <FreeTierGridItem item xs={6}>
          <CycleTimeWidget
            isLodingCycleTimeData={isLodingCycleTimeData}
            cycleTimeTrendData={cycleTimeTrendData}
            cycleTimeAverage={cycleTimeAverage}
            totalCycleTimeInMinutes={totalCycleTimeInMinutes}
            pipelineMilestones={pipelineMilestones}
          />
        </FreeTierGridItem>

        {widgets.map(widgetData => {
          return (
            <widgetData.GridItem
              item
              xs={widgetData.gridSize}
              key={widgetData.metricName}
            >
              {widgetData.metricName ? (
                <MetricWidget
                  isWidgetLoading={isWidgetLoading}
                  widgetMetricName={widgetData.metricName}
                  selectedTeamId={selectedTeamId}
                  V3DataCalculated={V3DataCalculated}
                  formattedV3Data={formattedV3Data}
                  metricsPerGranularityMapped={metricsPerGranularityMapped}
                  metricsWidgetData={metricsWidgetData}
                  metricsWidgetsByName={metricsWidgetsByName}
                />
              ) : (
                widgetData.Component()
              )}
            </widgetData.GridItem>
          );
        })}
        <FreeTierLastInLineGridItem item xs={4}>
          <CallToActionSlides />
        </FreeTierLastInLineGridItem>
      </GridWrapper>
      {isFreePlan && <EducationalTabs />}
    </>
  );
};

export default AllContributorsDoraDashboard;
